import { render, staticRenderFns } from "./CarouselDefaultShowItem.vue?vue&type=template&id=b5e0044e&"
import script from "./CarouselDefaultShowItem.vue?vue&type=script&lang=js&"
export * from "./CarouselDefaultShowItem.vue?vue&type=script&lang=js&"
import style0 from "./CarouselDefaultShowItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports